import { render } from "./index.vue?vue&type=template&id=be899bdc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=be899bdc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be899bdc"],['__file',"src/views/userCenter/tagEdit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be899bdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be899bdc', __exports__)) {
    console.log('reload')
    api.reload('be899bdc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=be899bdc&scoped=true", () => {
    console.log('re-render')
    api.rerender('be899bdc', render)
  })

}


export default __exports__